import { Row } from 'react-bootstrap';
import styled from 'styled-components';
import { calcResize } from 'components/Layout/styles';

export const SAnswer = styled.div`
  p {
    font-size: ${calcResize(14, 18)};
  }
`;
